import React, { useEffect } from "react";
import { GetdecodedURL } from "./api";

//Update log
//FB 4763  DK   10/21/2021      Added to redirect the page from short url's
//

export async function getdecodedURL(
    urlcode: string
): Promise<string> {
    const decodedURL = await GetdecodedURL(urlcode);
    return decodedURL;
}


export default function Page_redirector(props: any) {
    let urlcode = props.match.params.urlcode;

    useEffect(() => {
        onload();
    });

    const onload = async () => {
        const redirectURL = await getdecodedURL(urlcode);


        if (!(redirectURL === "" || redirectURL === undefined)) {
            window.location.href = redirectURL;
        }
    }
    return (<div></div>)
}